import { Icon } from '@mui/material';
import { WorkflowCompletionForm } from '@ovComponents/4-module/workflowCompletion/components/workflowCompletionForm';
import { InlineImage } from '@pages/ClientDetail/documents/inlineImage';
import { InlineImageLocal } from '@pages/ClientDetail/documents/inlineImageLocal';
import { AnalyticsContext } from '@providers/analyticsProvider';
import { ovAnalyticsEvents } from '@utils/analytics/analytics';
import { Box, Grid, Typography, useTheme } from 'hephaestus/web';
import { kebabCase } from 'lodash-es';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useLocalization } from '../../../../../hooks/useLocalization';

export const ReviewVisual = ({
  options,
  loading,
  continueFunc,
}: {
  options: any;
  loading: boolean;
  continueFunc: any;
}) => {
  const { translateBackendString } = useLocalization();
  const { t } = useTranslation(['workflowCompletions']);
  const theme = useTheme();
  const { sendAnalytic } = useContext(AnalyticsContext);
  const submit = async () => {
    sendAnalytic(ovAnalyticsEvents.workflowsReviewContinueButtonSelect);
    await continueFunc();
  };

  const styles: any = {
    objectFit: 'cover',
    minHeight: '60px',
    width: '80px',
    borderRadius: '15px',
  };

  return (
    <WorkflowCompletionForm
      onSubmit={submit}
      submitButtonProps={{
        dataTestId: `review-${kebabCase(options?.title?.en)}-continue-button`,
        label: t('workflowCompletions:continue'),
        disabled: loading,
      }}
    >
      <Typography variant='displayLarge' sx={{ mt: 1 }}>
        {translateBackendString(options?.title)}
      </Typography>
      <Typography variant='bodyLarge' sx={{ mb: 5 }}>
        <ReactMarkdown linkTarget='_blank' remarkPlugins={[remarkGfm]}>
          {translateBackendString(options?.subtitle)}
        </ReactMarkdown>
      </Typography>
      {options?.options?.map((option: any) => (
        <Box
          sx={{
            display: 'flex',
            mb: 5,
            opacity: option.state === 'DISABLED' ? 0.4 : 1,
          }}
        >
          {option?.value?.file && (
            <Box
              sx={{
                mr: 2,
              }}
            >
              <InlineImageLocal file={option?.value?.file} style={styles} />
            </Box>
          )}
          {option?.value?.value && (
            <Box
              sx={{
                mr: 2,
              }}
            >
              <InlineImage
                fileDocumentId={option?.value?.value}
                style={styles}
              />
            </Box>
          )}
          <Grid container size={12}>
            <Grid size={option?.icon ? 11 : 12}>
              <Box>
                <Typography variant='headingSmall' sx={{ mb: 0.5 }}>
                  {translateBackendString(option.title)}
                </Typography>
                <Typography variant='bodyLarge'>
                  {translateBackendString(option.subtitle)}
                </Typography>
              </Box>
            </Grid>
            {option?.icon ? (
              <Grid
                size={option.trailing ? 1 : 0}
                sx={{
                  ml: 'auto',
                }}
              >
                <Icon sx={{ fontSize: '30px', color: theme.color.onSurface }}>
                  {option.icon}
                </Icon>
              </Grid>
            ) : null}
          </Grid>
        </Box>
      ))}
    </WorkflowCompletionForm>
  );
};

export default ReviewVisual;
